import moment from "moment-timezone";
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
export const truncateText = (text, maxLength) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};
// Rich-text (editor HTML) -> plain text, also decodes entities like &nbsp; / &amp;
export const stripHtml = (html) => {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
};
export const getFullName = (FirstName = "", LastName = "") => {
  return `${FirstName || "-"} ${LastName || "-"} `
}
//  get value if value is coming array for payload
export const getValue = (data, key = "value") => data[0]?.[key]

export const combineDateAndTimeToUTC = (date, time) => {
  if (!date || !time) return null;

  // Extract date and time parts correctly
  const datePart = moment.utc(date).format("YYYY-MM-DD");
  const timePart = moment.utc(time).format("HH:mm");

  // Combine date and time, convert to UTC
  const dateTimeUTC = moment.utc(`${datePart} ${timePart}`, "YYYY-MM-DD HH:mm").format();

  return dateTimeUTC;
};
export const onSort = (columnKey = null, sortConfig, setSortConfig) => {
  let direction = -1;
  if (sortConfig.sortValue === columnKey) {
    direction = sortConfig.sortOrder === 1 ? -1 : 1;
  }
  setSortConfig((prev) => ({
    ...prev,
    sortValue: columnKey,
    sortOrder: direction,

  }));
};

export const handleTrimmedValue = (value = "") => {
  const isTrimmedEmpty = typeof value === "string" && value?.trim()?.length === 0;
  return isTrimmedEmpty ? value?.trim() : value;
};

export const getLocalizedText = (item, key, isEnglish) => {
  return isEnglish ? item?.[key] : item?.[`${key}_ar`] || item?.[key];
};

export function extractCity(addressComponents) {
  if (!addressComponents) return "";
  const locality = addressComponents.find(c => c.types.includes("locality"));
  if (locality) return locality.long_name;
  const adminArea = addressComponents.find(c => c.types.includes("administrative_area_level_1"));
  if (adminArea) return adminArea.long_name;
  const adminArea2 = addressComponents.find(c => c.types.includes("administrative_area_level_2"));
  if (adminArea2) return adminArea2.long_name;
  return "";
}

export const TIMEZONE = () => {
  if (timeZone === "Asia/Calcutta" || timeZone === "Asia/Kolkata") {
    let indiaTimezone = "Asia/Kolkata"
    return indiaTimezone
  } else {
    return timeZone
  }
}


export function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}

// Seat locks of a guest (picking seats before logging in to pay) are owned by this random key of the browser
const SEAT_GUEST_KEY = "seatGuestKey"

const newGuestKey = () => window.crypto?.randomUUID?.() ||
    "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) => (c ^ (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16))

export const getSeatGuestKey = () => {
    try {
        let key = localStorage.getItem(SEAT_GUEST_KEY)
        if (!key) {
            key = newGuestKey()
            localStorage.setItem(SEAT_GUEST_KEY, key)
        }
        return key
    } catch (e) {
        return null
    }
}
